var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('h1',{staticClass:"heading1"},[_vm._v("Whoops, something went wrong.")]),_c('p',[_vm._v("Let's try that again?")]),_c('a',{staticClass:"button button--white",attrs:{"href":"/"}},[_vm._v("Back Home")])])
}]

export { render, staticRenderFns }